import { Image } from '@atoms/Images';
import { userAtom } from '@states/Atoms';
import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

const UserInfo = () => {
    const userInformation: any = useRecoilValue(userAtom.infomationState);
    return (
        <UserInformationWithStyled className='loginUser'>
            <NavDropdown title={<Image src="/img/icon/iconmonstr-user-6-32.png" alt="ログイン情報" />}>
                <NavDropdown.ItemText>{userInformation.name} さん</NavDropdown.ItemText>
            </NavDropdown>
        </UserInformationWithStyled>
    );
};

const UserInformationWithStyled = styled.div`
`
export default UserInfo;